import { createBox } from '@shopify/restyle';
import { TextInput, TextInputProps } from 'react-native';
import type { Theme } from '../../theme/theme';

export const BasicInput = createBox<Theme, TextInputProps>(TextInput);
